import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Numeral from "react-numeral";
import moment from "moment";
import { LinkItUrl } from "react-linkify-it";
import { Link } from "react-router-dom";
import BalancePaymentForm from "./BalancePaymentForm";
import Footer from "./Footer";
import { Alert } from "reactstrap";
import {
  AlertModal,
  InfoModal,
  LoadingModal,
  SuccessModal,
} from "../AlertModals";
import {
  getApprovalFulfillmentStatus,
  getAxiosHeaders,
} from "../../../utils/Utils";
import { Icon } from "../../../components/Component";
import { baseURLs } from "../../../utils/Constants";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import ExpenseFulfillmentInfo from "./OrderInfo";

const Body = ({ history, expenseInfo, setExpenseInfo, ...props }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState({
    title: "",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [approvalNote, setApprovalNote] = useState("");

  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const reviewExpense = (status) => {
    if (status === "rejected" && approvalNote.length === 0) {
      setErrorMessage("Enter reason for rejecting the expense");
      return;
    }

    setErrorMessage("");
    toggleModal("loadingModal");

    axios
      .put(
        baseURLs.API_URL + `/expenses/approval/${expenseInfo.expense_id}`,
        {
          business_id: expenseInfo.business_id,
          response: status,
          note: approvalNote,
        },
        getAxiosHeaders()
      )
      .then((response) => {
        let responseInfo = response.data;

        let _expenseInfo = expenseInfo;

        _expenseInfo.fulfillment_status = responseInfo.data.fulfillment_status;
        _expenseInfo.status = responseInfo.data.status;
        setExpenseInfo({ ..._expenseInfo });
        setSuccessMessage({
          title: status === "approved" ? "Approved" : "Rejected",
          message: `The expense has been ${status} successfully`,
        });
        toggleModal("successModal");
      })
      .catch((error) => {
        try {
          let errorResponse = error.response.data;

          let errorMessage = "Error: Could not connect to server";
          if (errorResponse.hasOwnProperty("error")) {
            errorMessage = errorResponse.error;
          }

          setErrorMessage(errorMessage);
          toggleModal("errorModal");
        } catch (e) {
          setErrorMessage("Error: Could not connect to server");
          toggleModal("errorModal");
        }
      });
  };

  return (
    <>
      {/* items section*/}
      <div className="fm-content" key="body">
        <ul className="nk-top-products">
          {expenseInfo.items.map((data, index) => {
            return (
              <>
                <li className="item" key={index}>
                  <div className="info">
                    <div className="title">{data.expense_name}</div>
                    <div className="price mt-2">
                      {data.category}
                      {expenseInfo.expense_type === "stock" &&
                        ["Inventory", "Raw Materials"].includes(
                          data.category
                        ) && (
                          <>
                            {` • ${expenseInfo.currency}`} {data.unit_cost}{" "}
                            {`• Qty: ${data.quantity}`}
                          </>
                        )}
                    </div>
                  </div>
                  <div className="total">
                    <div className="amount">
                      <small className="text-muted">
                        {expenseInfo.currency}
                      </small>{" "}
                      {data.total_cost}
                    </div>
                  </div>
                </li>
              </>
            );
          })}
        </ul>
      </div>

      {/* summary section */}
      {expenseInfo.has_supplier === "yes" ? (
        <>
          {/* summary section */}
          <div className="fm-content bg-lighter">
            <div className="row">
              <div className="col-md-12">
                <div className="nk-iv-scheme-details">
                  <ul className="nk-iv-wg3-list w-100">
                    <li className="px-0 py-2 fw-medium">
                      <div className="sub-text fs-16px">Sub Total</div>
                      <div className="nk-wg-action-content p-0">
                        <h4 className="amount fs-16px">
                          <small className="text-muted me-1">
                            {expenseInfo.currency}
                          </small>
                          {expenseInfo.sub_total_amount}
                        </h4>
                      </div>
                    </li>
                    <li className="px-0 py-2 d-block">
                      <div className="d-flex justify-content-between fw-medium">
                        <div className="sub-text fs-14px">Total Tax</div>
                        <div className="nk-wg-action-content p-0">
                          <h4 className="amount fs-14px">
                            <small className="text-muted me-1">
                              {expenseInfo.currency}
                            </small>
                            {expenseInfo.tax_amount}
                          </h4>
                        </div>
                      </div>
                    </li>
                    <li className="px-0 py-2">
                      <div className="sub-text fs-14px">Discount</div>
                      <div className="nk-wg-action-content p-0">
                        <h4 className="amount fs-14px">
                          <small className="text-muted me-1">
                            - {expenseInfo.currency}
                          </small>
                          {expenseInfo.discount_amount}
                        </h4>
                      </div>
                    </li>
                    <li className="px-0 py-2 fw-bold">
                      <div className="sub-text fs-18px">Total</div>
                      <div className="nk-wg-action-content p-0">
                        <h4 className="amount fs-18px">
                          <small className="text-muted me-1">
                            {expenseInfo.currency}
                          </small>
                          {expenseInfo.total_amount}
                        </h4>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="nk-iv-scheme-details">
                  <ul className="nk-iv-wg3-list w-100">
                    <li className="px-0 py-2">
                      <div className="sub-text fs-14px">Amount Paid</div>
                      <div className="nk-wg-action-content p-0">
                        <h4 className="amount fs-14px">
                          <small className="text-muted me-1">
                            {expenseInfo.currency}
                          </small>
                          {expenseInfo.amount_paid}
                        </h4>
                      </div>
                    </li>
                    <li className="px-0 py-2 fw-bold">
                      <div
                        className={`sub-text fs-18px ${
                          expenseInfo.status === "owed" ? `text-danger` : ``
                        }`}
                      >
                        Balance Due
                      </div>
                      <div className="nk-wg-action-content p-0">
                        <h4
                          className={`amount fs-18px ${
                            expenseInfo.status === "owed" ? `text-danger` : ``
                          }`}
                        >
                          <small
                            className={`${
                              expenseInfo.status === "owed"
                                ? `text-danger`
                                : `text-muted`
                            } me-1`}
                          >
                            {expenseInfo.currency}
                          </small>
                          {expenseInfo.balance_due}
                        </h4>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              {expenseInfo.status === "paid" ? (
                <div className="col-md-12">
                  <div className="alert alert-fill alert-success alert-icon">
                    <em className="icon ni ni-check-circle"></em>{" "}
                    <strong>Paid in full</strong>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-md-12">
                    <div className="alert alert-fill alert-danger alert-icon mb-3">
                      <em className="icon ni ni-alert-circle"></em>
                      <span>
                        This expense is owed and yet to be paid in full.
                      </span>
                    </div>
                  </div>

                  <BalancePaymentForm
                    expenseInfo={expenseInfo}
                    setExpenseInfo={setExpenseInfo}
                  />
                </>
              )}

              {expenseInfo.note && (
                <div className="col-md-12 mt-5">
                  <hr className="mb-5" />
                  <p className="mb-1">
                    <strong>Note</strong>
                  </p>
                  <LinkItUrl>
                    <p style={{ whiteSpace: "pre-wrap" }}>{expenseInfo.note}</p>
                  </LinkItUrl>
                </div>
              )}

              {expenseInfo.attachment_url && (
                <div className="col-md-12 mt-5">
                  <hr className="mb-5" />
                  <Alert
                    color="primary"
                    className="alert-pro pointer-cursor"
                    onClick={() =>
                      window.open(expenseInfo.attachment_url, "_blank").focus()
                    }
                  >
                    <h6>Download Attachment File</h6>
                    <p>Click to download the expense attachment file.</p>
                  </Alert>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="fm-content bg-lighter">
          <div className="row">
            <div className="col-md-12">
              <div className="nk-iv-scheme-details">
                <ul className="nk-iv-wg3-list w-100">
                  <li className="px-0 py-2 fw-bold">
                    <div className="sub-text fs-18px">Total Amount</div>
                    <div className="nk-wg-action-content p-0">
                      <h4 className="amount fs-18px">
                        <small className="text-muted me-1">
                          {expenseInfo.currency}
                        </small>
                        <Numeral
                          value={expenseInfo.total_amount.toString()}
                          format={"0,0.00"}
                        />
                      </h4>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {expenseInfo.status === "paid" && (
              <div className="col-md-12">
                <div className="alert alert-fill alert-success alert-icon">
                  <em className="icon ni ni-check-circle"></em>{" "}
                  <strong>Paid in full</strong>
                </div>
              </div>
            )}

            {/* {
              expenseInfo.has_approval === 'yes' &&
              <div className="fm-footer" style={{backgroundColor: "#1c2b46"}}>
                <div className="nk-help">
                  <div className="nk-help-img w-100px mr-0">
                    {
                      expenseInfo.status === 'rejected' && 
                      <img src={OrderOutstandingIcon} width="80px" alt={getApprovalFulfillmentStatus(expenseInfo.status)} />
                    }

                    {
                      expenseInfo.status === 'pending_approval' && 
                      <img src={PendingApprovalIcon} width="80px" alt={getApprovalFulfillmentStatus(expenseInfo.status)} />
                    }

                    {
                      expenseInfo.status === 'approved' && 
                      <img src={ReadyForPickupIcon} width="80px" alt={getOrderStatus(expenseInfo.status)} />
                    }
                  </div>
                  <div className="nk-help-text">
                    <span className="sub-title text-white">Approval Status:</span>  
                    <h5 className="title text-white">{getOrderStatus(orderInfo.status)}</h5>
                    <p className="mb-0"><small className="text-white">Assigned To: {orderInfo.order_log[0].updated_by}</small></p>
                  </div>
                  {
                    orderInfo.fulfillment_status === 'pending_approval' &&
                    <div className="dark-mode nk-help-action text-md-center">
                      <button onClick={() => toggleModal('approvalModal')} className="btn btn-md btn-primary">Approve</button>
                    </div>
                  }
                </div>
              </div>
            } */}

            {expenseInfo.note && (
              <div className="col-md-12 mt-5">
                <hr className="mb-5" />
                <p className="mb-1">
                  <strong>Note</strong>
                </p>
                <LinkItUrl>
                  <p style={{ whiteSpace: "pre-wrap" }}>{expenseInfo.note}</p>
                </LinkItUrl>
              </div>
            )}

            {expenseInfo.attachment_url && (
              <div className="col-md-12 mt-5">
                <hr className="mb-5" />
                <Alert
                  color="primary"
                  className="alert-pro pointer-cursor"
                  onClick={() =>
                    window.open(expenseInfo.attachment_url, "_blank").focus()
                  }
                >
                  <h6>Download Attachment File</h6>
                  <p>Click to download the expense attachment file.</p>
                </Alert>
              </div>
            )}
          </div>
        </div>
      )}

      {expenseInfo.has_approval === "yes" && (
        <div className="fm-head bg-lighter justify-content-between flex-wrap">
          <div className="d-flex">
            <div className="fm-count">
              <Icon name="user-check fs-22px"></Icon>
            </div>
            <div className="fm-title">
              <h5 className="title fw-normal">
                {getApprovalFulfillmentStatus(expenseInfo.fulfillment_status)}
              </h5>
              {expenseInfo.fulfillment_status === "pending_approval" ? (
                <p className="nk-block-des">
                  From:{" "}
                  {`${expenseInfo.approve_by.full_name} - ${expenseInfo.approve_by.email}`}
                </p>
              ) : (
                <p className="nk-block-des">
                  By:{" "}
                  {`${expenseInfo.approve_by.full_name} - ${expenseInfo.approve_by.email}`}
                </p>
              )}
            </div>
          </div>
          {expenseInfo.fulfillment_status === "pending_approval" && (
            <button
              type="button"
              onClick={() => {
                setErrorMessage("");
                toggleModal("approvalModal");
              }}
              className={`btn btn-sm btn-outline-primary m-1`}
            >
              <span>Update Approval</span>
            </button>
          )}
        </div>
      )}

      {expenseInfo.expense_type === "stock" &&
        ["approved", "pending_delivery", "delivered"].includes(
          expenseInfo.fulfillment_status
        ) && (
          <>
            <ExpenseFulfillmentInfo
              expenseInfo={expenseInfo}
              setExpenseInfo={setExpenseInfo}
            />
            {/* <div className="fm-head bg-lighter justify-content-between flex-wrap">
              <div className="d-flex">
                <div className="fm-count">
                  <Icon name="truck fs-22px"></Icon>
                </div>
                <div className="fm-title">
                  <h5 className="title fw-normal">
                    {getApprovalFulfillmentStatus(
                      expenseInfo.fulfillment_status
                    )}
                  </h5>
                  <p className="nk-block-des">
                    Updated By: {`${expenseInfo.recorded_by}`}
                  </p>
                </div>
              </div>
              {expenseInfo.fulfillment_status === "pending_delivery" && (
                <button
                  type="button"
                  onClick={() => {
                    setErrorMessage("");
                    toggleModal("fulfillmentModal");
                  }}
                  className={`btn btn-sm btn-outline-primary m-1`}
                >
                  <span>Update Delivery</span>
                </button>
              )}
            </div> */}
          </>
        )}

      {/* footer section */}
      <Footer
        history={history}
        expenseInfo={expenseInfo}
        setExpenseInfo={setExpenseInfo}
      />

      {/* approval modal */}
      {activeModal === "approvalModal" && (
        <InfoModal
          index="approval"
          showModal={true}
          toggleModal={() => toggleModal("approvalModal")}
          headerText={`Approve this Expense?`}
          descriptionText={`Approving it will add it to your business expenses. If it’s not valid, you can reject it and the person who submitted it will be notified.`}
          leftButtonText={`Approve`}
          leftButtonOnClick={() => reviewExpense("approved")}
          rightButtonText={`Reject`}
          rightButtonOnClick={() => reviewExpense("rejected")}
        >
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label">Note</label>
                </div>
                <div className="form-control-wrap">
                  <TextArea
                    rows={4}
                    placeholder="Note"
                    onChange={(e) => {
                      setApprovalNote(e.target.value);
                    }}
                  />
                </div>
                {errorMessage && (
                  <p className="text-danger text-start mt-1">{errorMessage}</p>
                )}
              </div>
            </div>
          </div>
        </InfoModal>
      )}

      {/* Loading modal */}
      {activeModal === "loadingModal" && (
        <LoadingModal
          showModal={true}
          toggleModal={() => toggleModal("loadingModal")}
          headerText={`Updating...`}
          descriptionText={`Please wait while this expense is being updated...`}
        />
      )}

      {activeModal === "successModal" && (
        <SuccessModal
          showModal={true}
          toggleModal={() => toggleModal("successModal")}
          headerText={successMessage.title}
          descriptionText={successMessage.message}
        />
      )}

      {/* error modal */}
      {activeModal === "errorModal" && (
        <AlertModal
          showModal={true}
          toggleModal={() => toggleModal("errorModal")}
          headerText={"Error"}
          descriptionText={errorMessage}
        />
      )}
    </>
  );
};

export default Body;
